import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../shared/base/base.component';
import { SfAnalyticsService } from '../../services/sf-analytics.service';
import { LossReportService } from "../../services/loss-report.service";
import { RoutingService } from "../../services/routing.service";
import { Router } from "@angular/router";
import { LogService } from "../../services/log.service";





@Component({
  selector: 'olr-damage-photos-helpful-tips',
  templateUrl: './damage-photos-helpful-tips.component.html',
  styleUrl: './damage-photos-helpful-tips.component.css'
})
export class DamagePhotosHelpfulTipsComponent extends BaseComponent implements OnInit{

  @Output() filesUploaded = new EventEmitter<any>();
  pngHex = '89504e470d0a1a0a';
  jpgHex = 'ffd8ff';
  heicHex1 = '6674797068656963';
  heicHex2 = '667479706d696631';
  maxSize = 17; // 17MB
  finishedCheckingFiles = false;
  allowedTypes=['image/jpeg', 'image/png', 'image/jpg', 'image/heic'];
  newFiles:File[] = [];
  constructor(
        @Inject('Window') private window: any,
        public lossReportService: LossReportService,
        public routingService: RoutingService,
        public router: Router,
        private analytics: SfAnalyticsService,
        public logService: LogService
        ) {
          super(lossReportService, router, routingService, logService);
         }
    ngOnInit(): void {
      // console.log('I will add tagging for analytics');
      this.analytics.sendData('damage-photos-helpful-tips');
      this.analytics.setScreenChannel('filealoss-auto');

    }

  answerDamagePhotosQuestionht(answer: string): void {
    const step = this.lossReportService.getStepByName('damagePhotos');
    if (step) {

      // Assign the answer to the step's question
      step.question.answers = Array.isArray(answer) ? answer : [answer];

      // Mark the step as completed
      step.completed = true;

      // Optionally trigger additional logic
      if (step.question.hasDependentQuestions) {
        this.lossReportService.modifyReport();
      } else {
        this.routingService.navigateNext();
      }

    }

  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files || []);

    if (files.length <= 15) {
      const filePromises = files.map((file) =>
        this.checkFES(file).then((isFEW) => {
          if (isFEW) {
            if (file.name.endsWith('.heic')) {
              const approvedSize = file.size <= this.maxSize*1024*1024 && file.size > 0;
              if (!approvedSize) {
                this.window.alert(`File size exceeds limit for: ${file.name}`);
              }
              if (approvedSize) {
                this.newFiles.push(file);
              }
            } else {
              const allowedType = this.allowedTypes.includes(file.type);
              const approvedSize = file.size <= this.maxSize*1024*1024 && file.size > 0;

              if (!allowedType) {
                this.window.alert(`File type not allowed for: ${file.name}`);
              }
              if (!approvedSize) {
                this.window.alert(`File size exceeds limit for: ${file.name}`);
              }
              if (approvedSize && allowedType) {
                this.newFiles.push(file);
              }
            }
          } else {
            this.window.alert(`Something went wrong with the image: ${file.name}. Please try a different image.`);
            this.logService.log({id: 'MEDIA_UPLOAD_FILE_SIGNATURE_FAILURE', text: 'The file signature did not match the file extension'} )
          }
        })
      );
      Promise.all(filePromises).then(() => {
        this.filesUploaded.emit(this.newFiles);
      })
    }

  }

  checkFES(file: File): Promise<boolean> {
    return new Promise((resolve, reject)=>{
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadend = () => {
        if(reader.result && reader.result instanceof ArrayBuffer){
          const byteArr = new Uint8Array(reader.result.slice(0,12));
          // console.log(`THE BYTE ARRAY : ${byteArr}`)
          const hex = Array.from(byteArr).map(b => b.toString(16).padStart(2, '0')).join('');
          // console.log(`The hex pattern : ${hex}`)
          const isHEIC = (hex.includes(this.heicHex1) || hex.includes(this.heicHex2));
          const isJPG = hex.startsWith(this.jpgHex);
          const isPNG = hex.startsWith(this.pngHex);
          const isExSigMatch = (isHEIC && file.name.endsWith('.heic')) || (isJPG && file.type === 'image/jpg') || (isJPG && file.type === 'image/jpeg') || (isPNG && file.type === 'image/png');
          // console.log(`Saying it is a file extension and signature match would be ${isExSigMatch}`);
          resolve(isExSigMatch);
        }
        reject(false);
      };
    })
  }
}
